// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1rPDd","question":"Question_question__QBIIF","description":"Question_description__21tEv"};